import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { reportingService } from '../../services/reportingService';

export const useGetReportingDetail = reportingId => {
  return useQuery({
    queryKey: [QUERY_KEYS.reporting.detail, reportingId],
    queryFn: () =>
      reportingService.detail(reportingId).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
